import Button from 'ext-ui/components/Button/Button'
import React, { ReactElement } from 'react'
import {
  ReceiptRecoveryAccountingPeriod,
  ReceiptRecoveryStats,
  ReceiptRecoveryTransactionState,
} from 'src/feature/ReceiptRecovery/receiptRecovery.types'
import ReceiptRecoveryOverview from 'src/feature/ReceiptRecovery/ReceiptRecoveryOverview'
import { useTranslate } from 'src/localization/Trns'

import * as style from './ReceiptRecoveryWorkspace.style'

interface ReceiptRecoveryWorkspaceProps {
  accountingPeriods: readonly ReceiptRecoveryAccountingPeriod[]
  isRunAvailable?: boolean
  isRunPending: boolean
  onOpenTransactions: (state: ReceiptRecoveryTransactionState) => void
  onPeriodSelect: (periodId: string) => void
  onRunReceiptRecovery: () => void
  mockMissingReceiptCount?: number
  receiptStats: ReceiptRecoveryStats
  selectedPeriodId: string
}

const ReceiptRecoveryWorkspace = ({
  accountingPeriods,
  isRunAvailable = true,
  isRunPending,
  onOpenTransactions,
  onPeriodSelect,
  onRunReceiptRecovery,
  mockMissingReceiptCount,
  receiptStats,
  selectedPeriodId,
}: ReceiptRecoveryWorkspaceProps): ReactElement => {
  const translate = useTranslate()
  const selectedPeriod = accountingPeriods.find(
    (period) => period.id === selectedPeriodId,
  )

  return (
    <main css={style.workspace} data-testid="receipt-recovery-page">
      <header className="pageHeader">
        <div>
          <p className="eyebrow">
            {translate('RECEIPT AGENT · RECEIPT RECOVERY WORKSPACE')}
          </p>
          <h1>{translate('Receipt Recovery')}</h1>
          <p className="subtitle">
            {translate('${period} in view', {
              period: selectedPeriod?.label ?? '',
            })}
          </p>
        </div>
        <Button
          disabled={!isRunAvailable || isRunPending}
          loading={isRunPending}
          variant="primary"
          onClick={onRunReceiptRecovery}
        >
          {translate('Run Receipt Recovery')}
        </Button>
      </header>
      <ReceiptRecoveryOverview
        accountingPeriods={accountingPeriods}
        onOpenTransactions={onOpenTransactions}
        onPeriodSelect={onPeriodSelect}
        mockMissingReceiptCount={mockMissingReceiptCount}
        receiptStats={receiptStats}
        selectedPeriodId={selectedPeriodId}
      />
    </main>
  )
}

export default ReceiptRecoveryWorkspace
